import { z } from 'zod';

// What Tax Ops actually paid the state. It can differ from the accepted amount
// (penalty and interest accrue daily), and it is the figure the customer is told.
export const balanceDueMarkPaidSchema = z.object({
  amountPaid: z
    .string()
    .trim()
    .min(1, 'Amount paid is required')
    .regex(/^\d+(\.\d{1,2})?$/, 'Enter a dollar amount')
    .refine(value => Number(value) > 0, 'Amount paid must be greater than 0'),
});

export type BalanceDueMarkPaidValues = z.infer<typeof balanceDueMarkPaidSchema>;
